import React from 'react';
import DuelForm from '../components/duels/DuelForm';

/**
 * Страница создания дуэли
 */
function CreateDuelPage() {
    return (
        <div className="create-duel-page">
            <DuelForm />
        </div>
    );
}

export default CreateDuelPage;
